import React from "react";


const BookingCard = ({title, dec, sym, price, info}) => {
  return (
    <div className=" d-flex justify-content-between ">
      <div className=" w-100 booking-card-left">
        <h2>{title}</h2>
        <p>
          {dec}
        </p>
      </div>
      <div className="w-100 text-end booking-card-right">
        <h1>
          <span>{sym} </span>{price}
        </h1>
        <p>{info}</p>
      </div>
    </div>
  );
};

export default BookingCard;
